import mutations from './bno.mutations'
import actions from './bno.actions'
import getters from './bno.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
